import React from "react";
import { config } from "../config";
import { useInView } from 'react-intersection-observer';
import { Link } from "react-router-dom";
import welcome from "../../assets/images/welcome.jpg";

const ServiceSection = () => {
  return (
    <>
      <section class="about">
        <div class="container">

          <p class="sub-title">Welcome To Roliox Alloys</p>

          <h1 class="title text-decoration-uppercase">
            Leading Aluminum Recycling & Ingot Manufacturing Company
          </h1>

          <div class="desc">
            <p>
              We specialize in recycling aluminum scrap including UBC scrap, aluminum foils, and aluminum radiators. Using advanced melting and refining processes, we manufacture high-quality aluminum cubes and aluminum ingots for industrial use.
            </p>
          </div>

          <div class="features">

            <div class="feature left top">
              <h3>Reliable Bulk Supply</h3>
              <p>Strong sourcing of aluminum scrap.</p>
            </div>

            <div class="feature left bottom">
              <h3>High Purity Standards</h3>
              <p>Aluminum recycling process removes impurities.</p>
            </div>

            <div class="center-image">
              <img src={welcome} alt="building" />
            </div>


            <div class="feature right top">
              <h3>Consistent Quality</h3>
              <p>Maintain consistent composition quality.</p>
            </div>

            <div class="feature right bottom">
              <h3>24/7 Secure Operations</h3>
              <p>complete security and monitored processes</p>
            </div>

          </div>

        </div>
      </section>
    </>
  );
};

export default ServiceSection;
